import SeoLandingTemplate from "./SeoLandingTemplate";

export default function PhotoboothRentalBelgium() {
  return (
    <SeoLandingTemplate
      keyword="Photobooth Rental Belgium"
      path="/photobooth-rental-belgium"
      title="Photobooth Rental Belgium — Vespa, 120°, AI & VR | OneTec"
      description="Premium photobooth rental in Belgium. Choose from Vespa photobooth, 120° bullet-time, AI face swap, mosaic wall, light painting, Amsterdammer cargo bike. Branded, delivered, installed."
      serviceType="Photobooth Rental"
      hero={{
        eyebrow: "Service · Brand Activation",
        headline: (
          <>
            Photobooth rental
            <br />
            <span className="bg-ot-peach border-2 border-ot-fg px-2">in Belgium.</span>
          </>
        ),
        subhead:
          "The most photogenic photobooth fleet in Belgium. From the iconic Vespa and Dutch Amsterdammer cargo bike to bullet-time 120° rigs, AI face swap, mosaic walls and light painting — branded, delivered, installed.",
      }}
      intro={[
        "Photobooth rental in Belgium is a crowded market. Most of what's on offer is a glorified webcam in a plastic box with a sad backdrop. OneTec is the opposite: we engineer photobooths that crowds queue for, post on socials, and remember six months later. Since 2002, we've been the Belgian agency events teams call when they're done with generic photobooths and want something nobody else has.",
        "Our photobooth rental catalog in Belgium is the broadest in the country. **The Incredible Vespa**: a vintage Vespa transformed into a mobile photobooth — guests hop on, pose, and receive a branded print in seconds. **The Amsterdammer**: a wooden Dutch cargo bike, perfect for outdoor pop-ups and street activations. **The 120° Experience**: a semicircle of synchronized cameras producing cinematic, Matrix-style bullet-time video clips. **Studio from the Sky**: a top-down photo studio where gravity disappears — guests appear to fly, float or swim. **Studio Upside Down**: a fully inverted room where chairs stick to the ceiling.",
        "Every photobooth rental we deliver in Belgium comes branded to your campaign — wrapped stations, branded prints (PVC, glossy, custom format), branded digital delivery via QR or email, and branded social-share watermarks. Our crew installs on-site, runs the booth for the entire event, and breaks it down. You don't lift a thing.",
      ]}
      benefits={[
        {
          title: "10+ photobooth concepts",
          body: "The widest photobooth catalog in Belgium. Vespa, 120°, AI, VR, light painting, mosaic and more.",
        },
        {
          title: "Branded everything",
          body:
            "Wrapped station, branded prints, branded digital share, branded watermark on socials. Your campaign, end to end.",
        },
        {
          title: "Instant prints + digital",
          body:
            "Guests leave with a physical print AND receive the digital version by email or QR code in under 30 seconds.",
        },
        {
          title: "Belgian-built, EU-shipped",
          body:
            "Our photobooth fleet lives in our Zaventem warehouse. We deliver to Brussels, Antwerp, Ghent — and to Paris, Amsterdam, Luxembourg.",
        },
        {
          title: "Crew included",
          body:
            "Every photobooth rental includes a trained operator who manages the booth, queue, technical issues and guest experience.",
        },
        {
          title: "Insured fleet",
          body:
            "Our entire photobooth inventory is insured and tested before every event. If something breaks, we have spares on-site.",
        },
      ]}
      features={[
        "Vespa Photobooth (vintage scooter prop)",
        "Amsterdammer cargo-bike photobooth (outdoor)",
        "120° Experience (bullet-time multi-camera)",
        "Studio from the Sky (top-down studio)",
        "Studio Upside Down (inverted room)",
        "Light Painting Experience (neon wands, long exposure)",
        "Mosaic Photo Experience (live brand reveal wall)",
        "AI Face Swap photobooth",
        "Custom-branded transfer press merch station",
        "Operator + setup + breakdown included",
      ]}
      useCases={[
        { title: "Weddings & Galas", body: "Vespa + light painting = unforgettable mood." },
        { title: "Corporate Parties", body: "120° + AI face swap = social reach machine." },
        { title: "Brand Pop-Ups", body: "Amsterdammer cargo bike for street-level activation." },
        { title: "Festival Sponsorships", body: "Multi-station setup for thousands of attendees." },
      ]}
      faqs={[
        {
          q: "How much does photobooth rental cost in Belgium?",
          a: "Photobooth rental in Belgium starts around €1,200 for a half-day with a single booth and operator. Premium options like the 120° bullet-time rig, AI face swap or VR experience start higher. Get a tailored quote via our contact form — we reply within 24 hours.",
        },
        {
          q: "How far in advance should I book?",
          a: "For standard photobooth rentals (Vespa, Light Painting), 2 weeks lead time is enough. For complex setups (120° rig, custom AI content, multi-station), book 6-8 weeks ahead, especially in peak season (May-July, October-December).",
        },
        {
          q: "Do you deliver outside Brussels?",
          a: "Yes — anywhere in Belgium and across the EU. Most of Belgium is same-day delivery from our Zaventem warehouse. Pan-European delivery available with no extra hidden fees.",
        },
        {
          q: "Can the photobooth be branded to my campaign?",
          a: "Always. Branded wraps on the station, branded print templates, branded digital watermarks, branded social-share frames. We provide the prep work; you provide the brand guidelines.",
        },
        {
          q: "Is the photobooth GDPR-compliant?",
          a: "Yes. We capture explicit consent for photo use, store data in EU data centers, and provide opt-out at any time. Our full Privacy Policy details the data handling.",
        },
      ]}
      relatedProducts={[
        { slug: "the-incredible-vespa", name: "The Incredible Vespa" },
        { slug: "the-120-experience", name: "The 120° Experience" },
        { slug: "studio-from-the-sky", name: "Studio from the Sky" },
        { slug: "the-amsterdammer", name: "The Amsterdammer" },
      ]}
    />
  );
}
